import React from 'react';
import { formatDateTime } from '../../utils/dateFormat';

/**
 * Unified dashboard tab header (docs/dashboard-ui.md).
 *
 * The active tab name already tells the user where they are, so the header
 * never repeats it. It only carries what the tab name cannot:
 *   - description: one sentence on what the numbers cover / where they come from
 *   - lastUpdated: Date or ISO string, printed as "Last updated: <datetime>"
 *   - actions: right-aligned buttons, in the fixed order
 *     view toggle → Refresh (blue) → Export Excel (green)
 *
 * With nothing to show it renders nothing at all — chart-only tabs simply
 * don't mount a header.
 */
const DashboardTabHeader = ({ description, lastUpdated, actions }) => {
  if (!description && !lastUpdated && !actions) return null;
  return (
    <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2">
      {(description || lastUpdated) && (
        <div className="min-w-0">
          {description && <p className="text-sm text-slate-600">{description}</p>}
          {lastUpdated && (
            <p className="text-xs text-slate-500 mt-1">
              Last updated: {formatDateTime(lastUpdated)}
            </p>
          )}
        </div>
      )}
      {actions && <div className="flex items-center gap-2 ml-auto">{actions}</div>}
    </div>
  );
};

export default DashboardTabHeader;
